// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type BellFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from bell-filled.svg
 */
export default function BellFilledIcon(props: BellFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="BellFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M9.873 1.298a2 2 0 0 0-3.746 0A6 6 0 0 0 2 7v2.5H1a1 1 0 0 0 0 2h14a1 1 0 1 0 0-2h-1V7c0-2.66-1.73-4.915-4.127-5.702M10.13 12.5a.27.27 0 0 0-.25.185 2 2 0 0 1-3.76 0 .27.27 0 0 0-.25-.185H4.313a.237.237 0 0 0-.238.28 4.001 4.001 0 0 0 7.848 0 .237.237 0 0 0-.238-.28z"
        />
      </g>
    </svg>
  );
}
